module.exports = __webpack_public_path__ + "img/attention.a2f80fde.png";